import { Button } from '@toggle/design-system';
import styled from 'styled-components';

export const ReplyMessage = styled.p`
  padding: 8px 0px;
  flex: 3;
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledButton = styled(Button)`
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
`;
